import { render, staticRenderFns } from "./PrintContract.vue?vue&type=template&id=2f831c5b&scoped=true&"
import script from "./PrintContract.vue?vue&type=script&lang=js&"
export * from "./PrintContract.vue?vue&type=script&lang=js&"
import style0 from "./PrintContract.vue?vue&type=style&index=0&id=2f831c5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f831c5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VContainer,VIcon,VRow,VSnackbar})
